(() => {
  const init = () => {
    if (!document.body || document.body.dataset.giftingPdpReady === 'true') return;
    const template = document.querySelector('#MainContent')?.dataset.template || '';
    if (!template.startsWith('product')) return;

    const title = document.querySelector('.product-details h1, .product-details .product-title, [data-testid="product-title"]')?.textContent?.trim() || '';
    if (/caixa presente/i.test(title)) return;

    const buyButtons = document.querySelector('.product-details .buy-buttons-block');
    if (!buyButtons) return;

    const panel = document.createElement('div');
    panel.className = 'omnia-gifting-pdp';
    panel.setAttribute('role', 'note');
    panel.innerHTML = `
      <div class="omnia-gifting-pdp__media">
        <img src="https://cdn.shopify.com/s/files/1/0861/8721/3134/files/caixa-presente-omnia-a.jpg?v=1762960881" alt="Caixa Presente OMNIA" loading="lazy">
      </div>
      <div class="omnia-gifting-pdp__content">
        <p class="omnia-gifting-pdp__title">É PARA OFERECER?</p>
        <p class="omnia-gifting-pdp__copy">Depois de adicionares a peça ao carrinho, podes escolher a opção presente e pedir talão sem preço.</p>
      </div>`;

    buyButtons.insertAdjacentElement('afterend', panel);
    document.body.dataset.giftingPdpReady = 'true';
  };

  document.addEventListener('DOMContentLoaded', init, { once: true });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);
  setTimeout(init, 400);
})();
